import axios from "axios";
import { useUserStore } from "~/store/auth";
import CryptoJS from "crypto-js";
import { ref } from "vue";

export default defineNuxtPlugin(() => {
  const userStore = useUserStore();

  const config = useRuntimeConfig();
  const host = config.public.baseURL;
  const secureKey = config.public.secureKey;
  const tokenCookie = config.public.cookieName;
  const token = ref();
  let privateApi;
  const decryptedTokenAll = ref();

  const decryptToken = (encryptedToken: string): string => {
    const decryptedBytes = CryptoJS.AES.decrypt(encryptedToken, secureKey);
    return decryptedBytes.toString(CryptoJS.enc.Utf8);
  };

  const initializePrivateApi = (newToken: any) => {
    token.value = newToken;
    privateApi = axios.create({
      baseURL: host,
      headers: {
        common: {
          "Content-Type": "multipart/form-data",
        },
      },
    });

    privateApi.interceptors.request.use((requestConfig) => {
      if (token.value) {
        const decryptedToken = decryptToken(token.value);
        requestConfig.headers["Authorization"] = `Bearer ${decryptedToken}`;
      }

      return requestConfig;
    });

    privateApi.interceptors.response.use(
      (response) => response,
      (error) => {
        const errorCode = error.response?.data?.statusCode;
        if (errorCode === 403) {
          navigateTo({
            path: "/error",
            query: { statusCode: errorCode },
          });
        } else {
          console.error("Unhandled error code:", errorCode);
        }
        return Promise.reject(error);
      },
    );
  };

  const publicApi = axios.create({
    baseURL: host,
    headers: {
      common: {
        "Content-Type": "application/json",
      },
    },
  });

  initializePrivateApi(userStore.getItemWithExpiry(tokenCookie));

  const updateDecryptedToken = (newToken: any) => {
    token.value = newToken;
    decryptedTokenAll.value = decryptToken(token.value);
    token.value = userStore.getItemWithExpiry(tokenCookie);
  };

  token.value = userStore.getItemWithExpiry(tokenCookie);

  if (token.value) {
    decryptedTokenAll.value = decryptToken(token.value);
  }

  return {
    provide: {
      privateApi,
      publicApi,
      decryptedToken: decryptedTokenAll,
      initializePrivateApi,
      updateDecryptedToken,
    },
  };
});
